import { FC, ReactNode } from "react";
import { Anchor, Flex, MantineSpacing, MantineStyleProp } from "@mantine/core";
import { Link } from "react-router-dom";

interface ListRowProps {
  children: ReactNode;
  isFirst?: boolean;
  isLast?: boolean;
  highlighted?: boolean;
  highlightColor?: string;
  to?: string;
  gap?: MantineSpacing;
}

export const ListRow: FC<ListRowProps> = ({
  children,
  isFirst = false,
  isLast = false,
  highlighted = false,
  highlightColor,
  to,
  gap = "xs",
}) => {
  const style: MantineStyleProp = {
    borderBottom: !isLast ? "1px solid var(--mantine-color-gray-2)" : undefined,
    cursor: to ? "pointer" : undefined,
    borderRadius: isFirst ? "8px 8px 0 0" : isLast ? "0 0 8px 8px" : 0,
    background:
      highlighted && highlightColor
        ? `linear-gradient(90deg, ${highlightColor} 0%, transparent 100%)`
        : undefined,
  };

  const content = (
    <Flex align="center" py="xs" px="xs" gap={gap} style={style}>
      {children}
    </Flex>
  );

  if (to) {
    return (
      <Anchor component={Link} to={to} underline="never" c="inherit">
        {content}
      </Anchor>
    );
  }

  return content;
};
